package co.branch.jsonlogic.playground

fun main() {
    Playground().mount()
}
